$(document).ready(function(){

    if ($('.jump-nav').length) {
        var $window         = $(window);
        var $body           = $('body');
        var $jumpnav        = $('.jump-nav');
        var $nextSib        = $jumpnav.next();
        var $previousSib    = $('.hero-footer');
        var stickPoint      = $jumpnav.offset().top - $jumpnav.outerHeight();
        var  $navLink       = $('.jump-nav li');
        var  $section       = $('section[data-nav]');
        var $heroFooter     = $('.hero-footer');
        var $hero           = $('.hero');
        var $sibInitial     = $heroFooter.css('margin-bottom');
        var spaceReplace    = $jumpnav.outerHeight() 
                              + parseInt($heroFooter.css('margin-bottom'));

        /* Sticky Function */
        var stickySwitch = function() {
            var currentPosition = $window.scrollTop();

            if (currentPosition >= stickPoint) {
                if ($window.width() >= 500) {
                    $jumpnav.addClass('stick');
                    if ($heroFooter.length) {
                        $heroFooter.css('margin-bottom', spaceReplace);
                    } else {
                        $hero.css('margin-bottom', $jumpnav.outerHeight());
                    }
                }
            } else {
                if ($window.width() >= 500) {
                    $jumpnav.removeClass('stick');
                    if ($heroFooter.length) {
                        $heroFooter.css('margin-bottom', $sibInitial);
                    } else {
                        $hero.css('margin-bottom', 0);
                    }
                    stickPoint = $jumpnav.offset().top - $jumpnav.outerHeight();
                }
            }
        }

        stickySwitch();
        $window.scroll(stickySwitch);

        $window.resize(function() {
            stickPoint = $jumpnav.offset().top - $jumpnav.outerHeight();
        });

        /* Window Scroll */
        $navLink.on('click', function(){
            var dataNavLink = $(this).attr('data-nav');

            $section.each(function(){
                var dataNavSection  = $(this).attr('data-nav');
                var scrollPoint     = $(this).offset().top;

                if (dataNavSection == dataNavLink) {
                    $('html, body').animate({
                        scrollTop: scrollPoint - 150
                    });
                }
            });
        });

        /* Jump Nav Highlight */
        $window.scroll(function(){
            var currentPosition = $window.scrollTop();

            $navLink.each(function(){
                var dataNav             = $(this).attr('data-nav');
                var associatedElement   = $('section[data-nav="' + dataNav + '"]');

                if (associatedElement.offset().top <= (currentPosition + 200) && associatedElement.offset().top + associatedElement.height() > currentPosition) {
                    $navLink.removeClass('active');
                    $(this).addClass('active');
                } else {
                    $(this).removeClass('active');
                }
            });
        });
    }
});